import Swiper from "swiper/swiper-bundle.mjs";

const defaults = {
  loop: true,
  spaceBetween: 24,
  autoplay: {
    delay: 5000,
  },
  keyboard: {
    enabled: true,
  },
  mousewheel: {
    enabled: true,
    forceToAxis: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
};

const carousel = new Swiper(".carousel", {
  ...defaults,
  slidesPerView: 1.5,
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

const columns = new Swiper(".columns", {
  ...defaults,
  slidesPerView: 1.5,
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
  },
});

const testimonials = new Swiper(".testimonials", {
  ...defaults,
  slidesPerView: 1,
});
